import React from 'react';
import { useTranslation } from 'react-i18next';
import GenericTablePage from '../components/GenericTablePage';
import { GridColDef } from '@mui/x-data-grid';
import { stripHtml } from '../lib/htmlUtils';

const MessagesPage: React.FC = () => {
  const { t } = useTranslation();

  const columns: GridColDef[] = [
    { field: 'title', headerName: t('messages.messageTitle'), flex: 1, minWidth: 250 },
    { field: 'body', headerName: t('messages.body'), flex: 2, minWidth: 350, valueFormatter: (value) => stripHtml(value) },
  ];

  const fields = [
    {
      name: 'title',
      label: t('messages.messageTitle'),
      type: 'text' as const,
      required: true,
    },
    {
      name: 'body',
      label: t('messages.messageBody'),
      type: 'richtext' as const,
      required: true,
      width: 'full' as const,
    },
    {
      // Recipient company -> messages.company_id (uuid). Searchable company dropdown.
      name: 'company_id',
      label: t('messages.recipient'),
      foreignKey: { table: 'companies', valueField: 'id', labelField: 'name,pcu_id' },
    },
  ];

  return (
    <GenericTablePage 
      tableName="messages"
      title={t('messages.title')}
      columns={columns}
      fields={fields}
    />
  );
};

export default MessagesPage;
